import translations from './i18n';
const ext = {
  th: {
    // luckyfortune.js
    lf_wheel_event: 'กิจกรรมกงล้อ',
    lf_spin_daily: 'ปั่นกงล้อสุ่มรับรางวัล ได้ทุกวัน',
    lf_spinning: 'กำลังหมุน...',
    lf_ticket_remaining: 'ตั๋วคงเหลือ',
    lf_not_enough_ticket: 'ตั๋วไม่พอ',
    lf_no_ticket_text: 'คุณไม่มีตั๋วสำหรับหมุนกงล้อ',
    lf_spin_failed: 'หมุนกงล้อไม่สำเร็จ',
    // luckyfortune.js / cardminigame.js
    ft_game_not_open: 'เกมยังไม่เปิดให้บริการ',
    ft_no_records: 'ไม่พบรายการ...',
    // home.js
    hm_confirm_topup: 'ยืนยันการเติมเงิน',
    hm_cancel_qr_title: 'ยกเลิก QR code',
    hm_cancel_qr_text: 'คุณต้องการยกเลิกการใช้ Qr code',
    hm_same_password: 'คุณใส่รหัสผ่านเดิม',
    hm_no_password_input: 'คุณไม่ได้ไส่พาสเวิด',
    hm_password_min6: 'โปรดใส่พาสเวิดมากกว่า 6 ตัว',
    hm_select_bank_complete: 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน 6 ตัว',
    hm_min_withdraw_50: 'ขั้นต่ำในการถอน 50 บาท',
    hm_not_logged_in: 'คุณยังไม่ได้ล๊อคอิน',
    hm_not_logged_in2: 'คุณยังไม่ได้เข้าสู่ระบบ',
    hm_promo_received_topup: 'รับโปรโมชั่นเรียบร้อย โปรดทำการเติมเงิน',
    hm_promo_pending: 'ท่านมีการรับโปรโมชั่น ค้างไว้',
    hm_copy_success: 'คัดลอกสำเร็จ !!',
    hm_withdraw_bonus_q1: 'ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?',
    hm_withdraw_bonus_q2: 'คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)',
    hm_withdraw_bonus_title: 'ยืนยันการถอนโบนัส',
    hm_current_balance: 'ยอดเงินปัจจุบัน',
    hm_upload_slip: 'อัพโหลด Slip',
    hm_play_backup: 'เข้าเล่นสำรอง',
    hm_deposit_withdraw_history: 'ประวัติการฝากเงิน-ถอนเงิน',
    hm_month_all: 'ประจำเดือน : ทั้งหมด',
    hm_bonus: 'โบนัส',
    hm_specify_topup_min300: 'ระบุจำนวนเงินที่ต้องเติม *ขั้นต่ำ 300 บาท',
    hm_transfer_registered_only: 'กรุณาโอนจากบัญชีที่ลงทะเบียนเท่านั้น!!',
    hm_transfer_registered_phone: '***กรุณาโอนจากเบอร์ที่ลงทะเบียนเท่านั้น',
    hm_no_711: '***ไม่รับโอนผ่าน 7-11',
    hm_no_boonterm: '***ไม่รับโอนผ่านตู้บุญเติม',
    hm_truemoney_wallet: 'ทรูมันนี่วอลเล็ท',
    hm_same_name_only: 'ต้องเป็นชื่อเดียวกับที่ลงทะเบียนกับทางเว็บเท่านั้น!!!',
    hm_withdraw_to_bank: 'ถอนเงินเข้าบัญชีธนาคาร',
    hm_withdrawable_balance: 'ยอดเงินที่ถอนได้',
    hm_withdraw_min_100: 'ถอนขั้นต่ำ 100 บาท',
    hm_withdraw_min_100_note: '***ถอนขั้นต่ำ 100 บาท',
    hm_confirm_withdraw: 'ยืนยันการถอนเงิน',
    hm_none: 'ไม่มี',
    hm_your_bank: 'ธนาคารของคุณ',
    hm_old_password: 'รหัสผ่านเก่า',
    hm_old_password_note: '***พาสเวิดเก่า',
    hm_new_password_note: '***พาสเวิดใหม่',
    hm_confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
    hm_confirm_password_note: '***ยืนยันพาสเวิด',
    hm_affiliate_income: 'รายได้แนะนำเพื่อน',
    hm_income_last_week: 'รับรายได้สัปดาห์ที่แล้ว',
    hm_income_this_week: 'รายได้สัปดาห์นี้',
    hm_between_date: 'ระหว่างวันที่',
    hm_to: 'ถึง',
    hm_total_amount: 'ยอดรวม',
    hm_get_income: 'รับรายได้',
    hm_latest_income: 'รายได้ล่าสุด',
    hm_claim_invite: 'รับยอดชวนเพื่อน',
    hm_description: 'คำอธิบาย',
    hm_cashback_daily_note: 'รับยอดเล่นคืนทุกวันเวลา 01.00 น. ขั้นต่ำ 1 บาท : อัตรา 0.2 %',
    hm_cashback_weekly_note: 'คืนเงินรายสัปดาห์ 3% ทุกวันจันทร์ หลัง 01.00 น.',
    hm_friends_played_week: 'รายชื่อเพื่อนที่เล่นสัปดาห์นี้',
    hm_order: 'ลำดับ',
    hm_user_short: 'ยูส',
    hm_register_date: 'วันที่สมัคร',
    hm_amount: 'ยอด',
    hm_friends: 'เพื่อน',
    hm_invite_link: 'ลิงค์แนะนำ',
    hm_referred_friends: 'เพื่อนที่แนะนำ',
    hm_upload_slip_only: 'อัพโหลดเฉพาะภาพ Slip',
    hm_upload_slip_file: 'อัปโหลดไฟล์สลิป',
    hm_confirm_upload: 'ยืนยันการอัพโหลด',
    hm_upload_slip_success: 'อัปโหลดสลิปสำเร็จแล้ว',
    hm_invite_amount_note: 'ยอดชวนเพื่อน ทุกวันจันทร์ หลัง 01.00',
    hm_get_invite_amount: 'รับชวนเพื่อน 0.00 บาท',
    hm_weekly_cashback_note: 'คืนเงินยอดเสียรายสัปดาห์ 0.3% ทุกวันจันทร์ หลัง 01.00',
    hm_total_amount_zero: 'ยอดรวม 0.00 บาท',
    hm_get_cashback_amount: 'รับยอดคืน 0.00 บาท',
  },
  en: {
    lf_wheel_event: 'Wheel Event',
    lf_spin_daily: 'Spin the wheel for random prizes every day',
    lf_spinning: 'Spinning...',
    lf_ticket_remaining: 'Tickets remaining',
    lf_not_enough_ticket: 'Not enough tickets',
    lf_no_ticket_text: 'You have no tickets to spin the wheel',
    lf_spin_failed: 'Wheel spin failed',
    ft_game_not_open: 'The game is not open yet',
    ft_no_records: 'No records found...',
    hm_confirm_topup: 'Confirm top-up',
    hm_cancel_qr_title: 'Cancel QR code',
    hm_cancel_qr_text: 'Do you want to cancel using the QR code?',
    hm_same_password: 'You entered the same password',
    hm_no_password_input: 'You did not enter a password',
    hm_password_min6: 'Please enter a password longer than 6 characters',
    hm_select_bank_complete: 'Please select a bank or fill in complete information',
    hm_min_withdraw_50: 'Minimum withdrawal is 50 THB',
    hm_not_logged_in: 'You are not logged in',
    hm_not_logged_in2: 'You are not logged in yet',
    hm_promo_received_topup: 'Promotion received, please make a deposit',
    hm_promo_pending: 'You have a pending promotion',
    hm_copy_success: 'Copied successfully!!',
    hm_withdraw_bonus_q1: 'Do you want to withdraw a bonus of 0 credit?',
    hm_withdraw_bonus_q2: 'You will get credit back from (Slot: 0 Live Casino: 0 Sports: 0)',
    hm_withdraw_bonus_title: 'Confirm bonus withdrawal',
    hm_current_balance: 'Current balance',
    hm_upload_slip: 'Upload Slip',
    hm_play_backup: 'Backup Entry',
    hm_deposit_withdraw_history: 'Deposit-Withdrawal History',
    hm_month_all: 'Month : All',
    hm_bonus: 'Bonus',
    hm_specify_topup_min300: 'Specify the amount to top up *minimum 300 THB',
    hm_transfer_registered_only: 'Please transfer only from a registered account!!',
    hm_transfer_registered_phone: '***Please transfer only from a registered number',
    hm_no_711: '***Transfers via 7-11 not accepted',
    hm_no_boonterm: '***Transfers via Boonterm kiosk not accepted',
    hm_truemoney_wallet: 'TrueMoney Wallet',
    hm_same_name_only: 'Must be the same name as registered with the website only!!!',
    hm_withdraw_to_bank: 'Withdraw to bank account',
    hm_withdrawable_balance: 'Withdrawable balance',
    hm_withdraw_min_100: 'Minimum withdrawal 100 THB',
    hm_withdraw_min_100_note: '***Minimum withdrawal 100 THB',
    hm_confirm_withdraw: 'Confirm withdrawal',
    hm_none: 'None',
    hm_your_bank: 'Your bank',
    hm_old_password: 'Old password',
    hm_old_password_note: '***Old password',
    hm_new_password_note: '***New password',
    hm_confirm_new_password: 'Confirm new password',
    hm_confirm_password_note: '***Confirm password',
    hm_affiliate_income: 'Referral income',
    hm_income_last_week: 'Income from last week',
    hm_income_this_week: 'Income this week',
    hm_between_date: 'Between',
    hm_to: 'to',
    hm_total_amount: 'Total amount',
    hm_get_income: 'Claim income',
    hm_latest_income: 'Latest income',
    hm_claim_invite: 'Claim referral amount',
    hm_description: 'Description',
    hm_cashback_daily_note: 'Daily play cashback at 01:00, minimum 1 THB : rate 0.2 %',
    hm_cashback_weekly_note: 'Weekly cashback 3% every Monday after 01:00',
    hm_friends_played_week: 'List of friends who played this week',
    hm_order: 'No.',
    hm_user_short: 'User',
    hm_register_date: 'Registration date',
    hm_amount: 'Amount',
    hm_friends: 'Friends',
    hm_invite_link: 'Referral link',
    hm_referred_friends: 'Referred friends',
    hm_upload_slip_only: 'Upload only the Slip image',
    hm_upload_slip_file: 'Upload slip file',
    hm_confirm_upload: 'Confirm upload',
    hm_upload_slip_success: 'Slip uploaded successfully',
    hm_invite_amount_note: 'Referral amount every Monday after 01:00',
    hm_get_invite_amount: 'Claim referral 0.00 THB',
    hm_weekly_cashback_note: 'Weekly loss cashback 0.3% every Monday after 01:00',
    hm_total_amount_zero: 'Total amount 0.00 THB',
    hm_get_cashback_amount: 'Claim cashback 0.00 THB',
  },
  zh: {
    lf_wheel_event: '转盘活动',
    lf_spin_daily: '每天转动转盘随机赢取奖品',
    lf_spinning: '转动中...',
    lf_ticket_remaining: '剩余票数',
    lf_not_enough_ticket: '票数不足',
    lf_no_ticket_text: '您没有转动转盘的票',
    lf_spin_failed: '转动转盘失败',
    ft_game_not_open: '游戏尚未开放',
    ft_no_records: '未找到记录...',
    hm_confirm_topup: '确认充值',
    hm_cancel_qr_title: '取消 QR 码',
    hm_cancel_qr_text: '您要取消使用 QR 码吗？',
    hm_same_password: '您输入了相同的密码',
    hm_no_password_input: '您未输入密码',
    hm_password_min6: '请输入超过6位的密码',
    hm_select_bank_complete: '请选择银行或填写完整信息',
    hm_min_withdraw_50: '最低提款50泰铢',
    hm_not_logged_in: '您尚未登录',
    hm_not_logged_in2: '您尚未登录',
    hm_promo_received_topup: '已领取优惠，请进行充值',
    hm_promo_pending: '您有待处理的优惠',
    hm_copy_success: '复制成功！！',
    hm_withdraw_bonus_q1: '您要提取0信用额的奖金吗？',
    hm_withdraw_bonus_q2: '您将从（老虎机：0 真人娱乐场：0 体育：0）获得信用返还',
    hm_withdraw_bonus_title: '确认提取奖金',
    hm_current_balance: '当前余额',
    hm_upload_slip: '上传凭证',
    hm_play_backup: '备用入口',
    hm_deposit_withdraw_history: '存款-提款记录',
    hm_month_all: '月份 : 全部',
    hm_bonus: '奖金',
    hm_specify_topup_min300: '指定充值金额 *最低300泰铢',
    hm_transfer_registered_only: '请仅从已注册账户转账！！',
    hm_transfer_registered_phone: '***请仅从已注册号码转账',
    hm_no_711: '***不接受通过7-11转账',
    hm_no_boonterm: '***不接受通过Boonterm柜员机转账',
    hm_truemoney_wallet: 'TrueMoney钱包',
    hm_same_name_only: '必须与在网站注册的姓名一致！！！',
    hm_withdraw_to_bank: '提款至银行账户',
    hm_withdrawable_balance: '可提款余额',
    hm_withdraw_min_100: '最低提款100泰铢',
    hm_withdraw_min_100_note: '***最低提款100泰铢',
    hm_confirm_withdraw: '确认提款',
    hm_none: '无',
    hm_your_bank: '您的银行',
    hm_old_password: '旧密码',
    hm_old_password_note: '***旧密码',
    hm_new_password_note: '***新密码',
    hm_confirm_new_password: '确认新密码',
    hm_confirm_password_note: '***确认密码',
    hm_affiliate_income: '推荐收入',
    hm_income_last_week: '上周收入',
    hm_income_this_week: '本周收入',
    hm_between_date: '日期介于',
    hm_to: '至',
    hm_total_amount: '总额',
    hm_get_income: '领取收入',
    hm_latest_income: '最新收入',
    hm_claim_invite: '领取推荐金额',
    hm_description: '说明',
    hm_cashback_daily_note: '每天01:00返还游戏额，最低1泰铢 : 比率0.2 %',
    hm_cashback_weekly_note: '每周返现3%，每周一01:00后',
    hm_friends_played_week: '本周参与游戏的好友名单',
    hm_order: '序号',
    hm_user_short: '用户',
    hm_register_date: '注册日期',
    hm_amount: '金额',
    hm_friends: '好友',
    hm_invite_link: '推荐链接',
    hm_referred_friends: '已推荐的好友',
    hm_upload_slip_only: '仅上传凭证图片',
    hm_upload_slip_file: '上传凭证文件',
    hm_confirm_upload: '确认上传',
    hm_upload_slip_success: '凭证上传成功',
    hm_invite_amount_note: '推荐金额，每周一01:00后',
    hm_get_invite_amount: '领取推荐 0.00 泰铢',
    hm_weekly_cashback_note: '每周亏损返现0.3%，每周一01:00后',
    hm_total_amount_zero: '总额 0.00 泰铢',
    hm_get_cashback_amount: '领取返还 0.00 泰铢',
  },
  ja: {
    lf_wheel_event: 'ホイールイベント',
    lf_spin_daily: '毎日ホイールを回してランダムに賞品を獲得',
    lf_spinning: '回転中...',
    lf_ticket_remaining: '残りチケット',
    lf_not_enough_ticket: 'チケットが足りません',
    lf_no_ticket_text: 'ホイールを回すチケットがありません',
    lf_spin_failed: 'ホイールの回転に失敗しました',
    ft_game_not_open: 'ゲームはまだ開いていません',
    ft_no_records: '記録が見つかりません...',
    hm_confirm_topup: '入金を確認',
    hm_cancel_qr_title: 'QRコードをキャンセル',
    hm_cancel_qr_text: 'QRコードの使用をキャンセルしますか？',
    hm_same_password: '同じパスワードを入力しました',
    hm_no_password_input: 'パスワードが入力されていません',
    hm_password_min6: '6文字以上のパスワードを入力してください',
    hm_select_bank_complete: '銀行を選択するか、情報を完全に入力してください',
    hm_min_withdraw_50: '最低出金額は50バーツです',
    hm_not_logged_in: 'ログインしていません',
    hm_not_logged_in2: 'まだログインしていません',
    hm_promo_received_topup: 'プロモーションを受け取りました。入金してください',
    hm_promo_pending: '保留中のプロモーションがあります',
    hm_copy_success: 'コピーに成功しました！！',
    hm_withdraw_bonus_q1: '0クレジットのボーナスを出金しますか？',
    hm_withdraw_bonus_q2: '（スロット：0 ライブカジノ：0 スポーツ：0）からクレジットが返還されます',
    hm_withdraw_bonus_title: 'ボーナス出金を確認',
    hm_current_balance: '現在の残高',
    hm_upload_slip: 'スリップをアップロード',
    hm_play_backup: '予備エントリー',
    hm_deposit_withdraw_history: '入金・出金履歴',
    hm_month_all: '月 : すべて',
    hm_bonus: 'ボーナス',
    hm_specify_topup_min300: '入金額を指定 *最低300バーツ',
    hm_transfer_registered_only: '登録済みの口座からのみ振り込んでください！！',
    hm_transfer_registered_phone: '***登録済みの番号からのみ振り込んでください',
    hm_no_711: '***7-11経由の振込は受け付けません',
    hm_no_boonterm: '***Boonterm端末経由の振込は受け付けません',
    hm_truemoney_wallet: 'TrueMoneyウォレット',
    hm_same_name_only: 'ウェブサイトに登録した名前と同一でなければなりません！！！',
    hm_withdraw_to_bank: '銀行口座に出金',
    hm_withdrawable_balance: '出金可能残高',
    hm_withdraw_min_100: '最低出金100バーツ',
    hm_withdraw_min_100_note: '***最低出金100バーツ',
    hm_confirm_withdraw: '出金を確認',
    hm_none: 'なし',
    hm_your_bank: 'あなたの銀行',
    hm_old_password: '古いパスワード',
    hm_old_password_note: '***古いパスワード',
    hm_new_password_note: '***新しいパスワード',
    hm_confirm_new_password: '新しいパスワードを確認',
    hm_confirm_password_note: '***パスワードを確認',
    hm_affiliate_income: '紹介収入',
    hm_income_last_week: '先週の収入',
    hm_income_this_week: '今週の収入',
    hm_between_date: '期間',
    hm_to: 'から',
    hm_total_amount: '合計金額',
    hm_get_income: '収入を受け取る',
    hm_latest_income: '最新の収入',
    hm_claim_invite: '紹介額を受け取る',
    hm_description: '説明',
    hm_cashback_daily_note: '毎日01:00にプレイ額を還元、最低1バーツ : レート0.2 %',
    hm_cashback_weekly_note: '週間キャッシュバック3%、毎週月曜01:00以降',
    hm_friends_played_week: '今週プレイした友達のリスト',
    hm_order: '番号',
    hm_user_short: 'ユーザー',
    hm_register_date: '登録日',
    hm_amount: '金額',
    hm_friends: '友達',
    hm_invite_link: '紹介リンク',
    hm_referred_friends: '紹介した友達',
    hm_upload_slip_only: 'スリップ画像のみアップロード',
    hm_upload_slip_file: 'スリップファイルをアップロード',
    hm_confirm_upload: 'アップロードを確認',
    hm_upload_slip_success: 'スリップのアップロードに成功しました',
    hm_invite_amount_note: '紹介額、毎週月曜01:00以降',
    hm_get_invite_amount: '紹介を受け取る 0.00 バーツ',
    hm_weekly_cashback_note: '週間損失キャッシュバック0.3%、毎週月曜01:00以降',
    hm_total_amount_zero: '合計金額 0.00 バーツ',
    hm_get_cashback_amount: '還元を受け取る 0.00 バーツ',
  },
  my: {
    lf_wheel_event: 'ဘီးအီဗင့်',
    lf_spin_daily: 'နေ့စဉ်ဘီးလှည့်ပြီး ကျပန်းဆုလက်ဆောင်ရယူပါ',
    lf_spinning: 'လှည့်နေသည်...',
    lf_ticket_remaining: 'ကျန်ရှိသော လက်မှတ်',
    lf_not_enough_ticket: 'လက်မှတ်မလုံလောက်ပါ',
    lf_no_ticket_text: 'ဘီးလှည့်ရန် လက်မှတ်မရှိပါ',
    lf_spin_failed: 'ဘီးလှည့်ခြင်း မအောင်မြင်ပါ',
    ft_game_not_open: 'ဂိမ်း မဖွင့်ရသေးပါ',
    ft_no_records: 'မှတ်တမ်း မတွေ့ပါ...',
    hm_confirm_topup: 'ငွေဖြည့်ခြင်းကို အတည်ပြုပါ',
    hm_cancel_qr_title: 'QR ကုဒ်ကို ပယ်ဖျက်ရန်',
    hm_cancel_qr_text: 'QR ကုဒ်အသုံးပြုခြင်းကို ပယ်ဖျက်လိုပါသလား။',
    hm_same_password: 'စကားဝှက်အဟောင်းကို ထည့်ထားသည်',
    hm_no_password_input: 'စကားဝှက် မထည့်ထားပါ',
    hm_password_min6: 'အက္ခရာ ၆ လုံးထက်ပိုသော စကားဝှက်ထည့်ပါ',
    hm_select_bank_complete: 'ဘဏ်ရွေးချယ်ပါ သို့မဟုတ် အချက်အလက်အပြည့်အစုံ ဖြည့်ပါ',
    hm_min_withdraw_50: 'အနည်းဆုံး ထုတ်ယူခြင်း 50 ဘတ်',
    hm_not_logged_in: 'သင် Login ဝင်ထားခြင်း မရှိပါ',
    hm_not_logged_in2: 'သင် မဝင်ရသေးပါ',
    hm_promo_received_topup: 'ပရိုမိုးရှင်း ရရှိပြီးပါပြီ၊ ငွေဖြည့်ပါ',
    hm_promo_pending: 'ဆိုင်းငံ့ထားသော ပရိုမိုးရှင်းရှိသည်',
    hm_copy_success: 'ကူးယူ အောင်မြင်ပါသည်!!',
    hm_withdraw_bonus_q1: '0 ခရက်ဒစ်ဘောနပ်စ်ကို ထုတ်ယူလိုပါသလား။',
    hm_withdraw_bonus_q2: '(စလော့: 0 တိုက်ရိုက်ကာစီနို: 0 အားကစား: 0) မှ ခရက်ဒစ်ပြန်ရမည်',
    hm_withdraw_bonus_title: 'ဘောနပ်စ်ထုတ်ယူခြင်းကို အတည်ပြုပါ',
    hm_current_balance: 'လက်ရှိလက်ကျန်',
    hm_upload_slip: 'Slip တင်ရန်',
    hm_play_backup: 'အရန်ဝင်ရောက်ခြင်း',
    hm_deposit_withdraw_history: 'ငွေသွင်း-ငွေထုတ် မှတ်တမ်း',
    hm_month_all: 'လ : အားလုံး',
    hm_bonus: 'ဘောနပ်စ်',
    hm_specify_topup_min300: 'ဖြည့်မည့်ပမာဏ သတ်မှတ်ပါ *အနည်းဆုံး 300 ဘတ်',
    hm_transfer_registered_only: 'မှတ်ပုံတင်ထားသော အကောင့်မှသာ လွှဲပါ!!',
    hm_transfer_registered_phone: '***မှတ်ပုံတင်ထားသော နံပါတ်မှသာ လွှဲပါ',
    hm_no_711: '***7-11 မှတဆင့် လွှဲခြင်း လက်မခံပါ',
    hm_no_boonterm: '***Boonterm စက်မှတဆင့် လွှဲခြင်း လက်မခံပါ',
    hm_truemoney_wallet: 'TrueMoney ပိုက်ဆံအိတ်',
    hm_same_name_only: 'ဝက်ဘ်ဆိုက်တွင် မှတ်ပုံတင်ထားသော အမည်နှင့် တူရမည်သာဖြစ်သည်!!!',
    hm_withdraw_to_bank: 'ဘဏ်အကောင့်သို့ ထုတ်ယူရန်',
    hm_withdrawable_balance: 'ထုတ်ယူနိုင်သော လက်ကျန်',
    hm_withdraw_min_100: 'အနည်းဆုံး ထုတ်ယူ 100 ဘတ်',
    hm_withdraw_min_100_note: '***အနည်းဆုံး ထုတ်ယူ 100 ဘတ်',
    hm_confirm_withdraw: 'ထုတ်ယူခြင်းကို အတည်ပြုပါ',
    hm_none: 'မရှိ',
    hm_your_bank: 'သင့်ဘဏ်',
    hm_old_password: 'စကားဝှက်အဟောင်း',
    hm_old_password_note: '***စကားဝှက်အဟောင်း',
    hm_new_password_note: '***စကားဝှက်အသစ်',
    hm_confirm_new_password: 'စကားဝှက်အသစ်ကို အတည်ပြုပါ',
    hm_confirm_password_note: '***စကားဝှက် အတည်ပြုပါ',
    hm_affiliate_income: 'မိတ်ဆက်ဝင်ငွေ',
    hm_income_last_week: 'ပြီးခဲ့သောအပတ် ဝင်ငွေ',
    hm_income_this_week: 'ဤအပတ် ဝင်ငွေ',
    hm_between_date: 'ရက်စွဲကြား',
    hm_to: 'မှ',
    hm_total_amount: 'စုစုပေါင်း',
    hm_get_income: 'ဝင်ငွေယူရန်',
    hm_latest_income: 'နောက်ဆုံးဝင်ငွေ',
    hm_claim_invite: 'မိတ်ဆက်ပမာဏ ယူရန်',
    hm_description: 'ဖော်ပြချက်',
    hm_cashback_daily_note: 'နေ့စဉ် 01:00 တွင် ကစားငွေပြန်အမ်း၊ အနည်းဆုံး 1 ဘတ် : နှုန်း 0.2 %',
    hm_cashback_weekly_note: 'အပတ်စဉ် ငွေပြန်အမ်း 3%၊ တနင်္လာတိုင်း 01:00 နောက်ပိုင်း',
    hm_friends_played_week: 'ဤအပတ်ကစားသော သူငယ်ချင်းစာရင်း',
    hm_order: 'အစဉ်',
    hm_user_short: 'ယူဇာ',
    hm_register_date: 'မှတ်ပုံတင်သည့်ရက်',
    hm_amount: 'ပမာဏ',
    hm_friends: 'သူငယ်ချင်းများ',
    hm_invite_link: 'မိတ်ဆက်လင့်ခ်',
    hm_referred_friends: 'မိတ်ဆက်ထားသော သူငယ်ချင်းများ',
    hm_upload_slip_only: 'Slip ပုံသာ တင်ပါ',
    hm_upload_slip_file: 'Slip ဖိုင် တင်ပါ',
    hm_confirm_upload: 'တင်ခြင်းကို အတည်ပြုပါ',
    hm_upload_slip_success: 'Slip တင်ခြင်း အောင်မြင်ပါသည်',
    hm_invite_amount_note: 'မိတ်ဆက်ပမာဏ၊ တနင်္လာတိုင်း 01:00 နောက်ပိုင်း',
    hm_get_invite_amount: 'မိတ်ဆက်ယူရန် 0.00 ဘတ်',
    hm_weekly_cashback_note: 'အပတ်စဉ် ရှုံးငွေပြန်အမ်း 0.3%၊ တနင်္လာတိုင်း 01:00 နောက်ပိုင်း',
    hm_total_amount_zero: 'စုစုပေါင်း 0.00 ဘတ်',
    hm_get_cashback_amount: 'ပြန်အမ်းငွေ ယူရန် 0.00 ဘတ်',
  },
  lo: {
    lf_wheel_event: 'ກິດຈະກຳກົງລໍ້',
    lf_spin_daily: 'ໝູນກົງລໍ້ສຸ່ມຮັບລາງວັນ ໄດ້ທຸກມື້',
    lf_spinning: 'ກຳລັງໝູນ...',
    lf_ticket_remaining: 'ປີ້ຄົງເຫຼືອ',
    lf_not_enough_ticket: 'ປີ້ບໍ່ພໍ',
    lf_no_ticket_text: 'ທ່ານບໍ່ມີປີ້ສຳລັບໝູນກົງລໍ້',
    lf_spin_failed: 'ໝູນກົງລໍ້ບໍ່ສຳເລັດ',
    ft_game_not_open: 'ເກມຍັງບໍ່ເປີດໃຫ້ບໍລິການ',
    ft_no_records: 'ບໍ່ພົບລາຍການ...',
    hm_confirm_topup: 'ຢືນຢັນການເຕີມເງິນ',
    hm_cancel_qr_title: 'ຍົກເລີກ QR code',
    hm_cancel_qr_text: 'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ QR code ບໍ?',
    hm_same_password: 'ທ່ານໃສ່ລະຫັດຜ່ານເກົ່າ',
    hm_no_password_input: 'ທ່ານບໍ່ໄດ້ໃສ່ລະຫັດຜ່ານ',
    hm_password_min6: 'ກະລຸນາໃສ່ລະຫັດຜ່ານຫຼາຍກວ່າ 6 ໂຕ',
    hm_select_bank_complete: 'ກະລຸນາເລືອກທະນາຄານ ຫຼື ໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ',
    hm_min_withdraw_50: 'ຖອນຂັ້ນຕ່ຳ 50 ບາດ',
    hm_not_logged_in: 'ທ່ານຍັງບໍ່ໄດ້ Login',
    hm_not_logged_in2: 'ທ່ານຍັງບໍ່ໄດ້ເຂົ້າສູ່ລະບົບ',
    hm_promo_received_topup: 'ຮັບໂປຣໂມຊັນຮຽບຮ້ອຍ ກະລຸນາເຕີມເງິນ',
    hm_promo_pending: 'ທ່ານມີໂປຣໂມຊັນຄ້າງໄວ້',
    hm_copy_success: 'ສຳເນົາສຳເລັດ !!',
    hm_withdraw_bonus_q1: 'ຕ້ອງການຖອນໂບນັດຈຳນວນ 0 ເຄຣດິດ ແມ່ນບໍ?',
    hm_withdraw_bonus_q2: 'ທ່ານຈະໄດ້ຮັບເຄຣດິດຄືນຈາກ (ສະລັອດ: 0 ຄາສິໂນສົດ: 0 ກິລາ: 0)',
    hm_withdraw_bonus_title: 'ຢືນຢັນການຖອນໂບນັດ',
    hm_current_balance: 'ຍອດເງິນປັດຈຸບັນ',
    hm_upload_slip: 'ອັບໂຫຼດ Slip',
    hm_play_backup: 'ເຂົ້າຫຼິ້ນສຳຮອງ',
    hm_deposit_withdraw_history: 'ປະຫວັດການຝາກເງິນ-ຖອນເງິນ',
    hm_month_all: 'ປະຈຳເດືອນ : ທັງໝົດ',
    hm_bonus: 'ໂບນັດ',
    hm_specify_topup_min300: 'ລະບຸຈຳນວນເງິນທີ່ຕ້ອງເຕີມ *ຂັ້ນຕ່ຳ 300 ບາດ',
    hm_transfer_registered_only: 'ກະລຸນາໂອນຈາກບັນຊີທີ່ລົງທະບຽນເທົ່ານັ້ນ!!',
    hm_transfer_registered_phone: '***ກະລຸນາໂອນຈາກເບີທີ່ລົງທະບຽນເທົ່ານັ້ນ',
    hm_no_711: '***ບໍ່ຮັບໂອນຜ່ານ 7-11',
    hm_no_boonterm: '***ບໍ່ຮັບໂອນຜ່ານຕູ້ Boonterm',
    hm_truemoney_wallet: 'TrueMoney Wallet',
    hm_same_name_only: 'ຕ້ອງເປັນຊື່ດຽວກັບທີ່ລົງທະບຽນກັບເວັບເທົ່ານັ້ນ!!!',
    hm_withdraw_to_bank: 'ຖອນເງິນເຂົ້າບັນຊີທະນາຄານ',
    hm_withdrawable_balance: 'ຍອດເງິນທີ່ຖອນໄດ້',
    hm_withdraw_min_100: 'ຖອນຂັ້ນຕ່ຳ 100 ບາດ',
    hm_withdraw_min_100_note: '***ຖອນຂັ້ນຕ່ຳ 100 ບາດ',
    hm_confirm_withdraw: 'ຢືນຢັນການຖອນເງິນ',
    hm_none: 'ບໍ່ມີ',
    hm_your_bank: 'ທະນາຄານຂອງທ່ານ',
    hm_old_password: 'ລະຫັດຜ່ານເກົ່າ',
    hm_old_password_note: '***ລະຫັດຜ່ານເກົ່າ',
    hm_new_password_note: '***ລະຫັດຜ່ານໃໝ່',
    hm_confirm_new_password: 'ຢືນຢັນລະຫັດຜ່ານໃໝ່',
    hm_confirm_password_note: '***ຢືນຢັນລະຫັດຜ່ານ',
    hm_affiliate_income: 'ລາຍໄດ້ແນະນຳໝູ່',
    hm_income_last_week: 'ຮັບລາຍໄດ້ອາທິດທີ່ແລ້ວ',
    hm_income_this_week: 'ລາຍໄດ້ອາທິດນີ້',
    hm_between_date: 'ລະຫວ່າງວັນທີ',
    hm_to: 'ຫາ',
    hm_total_amount: 'ຍອດລວມ',
    hm_get_income: 'ຮັບລາຍໄດ້',
    hm_latest_income: 'ລາຍໄດ້ລ່າສຸດ',
    hm_claim_invite: 'ຮັບຍອດຊວນໝູ່',
    hm_description: 'ຄຳອະທິບາຍ',
    hm_cashback_daily_note: 'ຮັບຍອດຫຼິ້ນຄືນທຸກວັນເວລາ 01.00 ນ. ຂັ້ນຕ່ຳ 1 ບາດ : ອັດຕາ 0.2 %',
    hm_cashback_weekly_note: 'ຄືນເງິນລາຍອາທິດ 3% ທຸກວັນຈັນ ຫຼັງ 01.00 ນ.',
    hm_friends_played_week: 'ລາຍຊື່ໝູ່ທີ່ຫຼິ້ນອາທິດນີ້',
    hm_order: 'ລຳດັບ',
    hm_user_short: 'ຍູສ',
    hm_register_date: 'ວັນທີສະໝັກ',
    hm_amount: 'ຍອດ',
    hm_friends: 'ໝູ່',
    hm_invite_link: 'ລິ້ງແນະນຳ',
    hm_referred_friends: 'ໝູ່ທີ່ແນະນຳ',
    hm_upload_slip_only: 'ອັບໂຫຼດສະເພາະຮູບ Slip',
    hm_upload_slip_file: 'ອັບໂຫຼດໄຟລ໌ສະລິບ',
    hm_confirm_upload: 'ຢືນຢັນການອັບໂຫຼດ',
    hm_upload_slip_success: 'ອັບໂຫຼດສະລິບສຳເລັດແລ້ວ',
    hm_invite_amount_note: 'ຍອດຊວນໝູ່ ທຸກວັນຈັນ ຫຼັງ 01.00',
    hm_get_invite_amount: 'ຮັບຊວນໝູ່ 0.00 ບາດ',
    hm_weekly_cashback_note: 'ຄືນເງິນຍອດເສຍລາຍອາທິດ 0.3% ທຸກວັນຈັນ ຫຼັງ 01.00',
    hm_total_amount_zero: 'ຍອດລວມ 0.00 ບາດ',
    hm_get_cashback_amount: 'ຮັບຍອດຄືນ 0.00 ບາດ',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
